import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/Home'
import Login from '@/pages/Login'
import ClientDetails from './pages/ClientDetails'
import NewClients from '@/pages/NewClients'
import Declarations from '@/pages/Declarations'
import InvoiceDetails from './pages/InvoiceDetails'
import DeclarationDetails from '@/pages/DeclarationDetails'
import Invoices from '@/pages/Invoices'
import EditClientPricelist from './pages/EditClientPricelist'
import Pricelist from './pages/Pricelist'
import EditPricelist from './pages/EditPricelist'
import Debts from './pages/Debts'
import CreditLimitExceededRaport from './pages/CreditLimitExceededRaport'
import Transactions from './pages/Transactions'
import store from './services/store'
import TollReport from './pages/TollReport'
import ServiceReport from './pages/ServiceReport'
import Users from './pages/Users'
import Services from "./pages/Services";
import Classifiers from "./pages/Classifiers";

Vue.use(VueRouter)

let router = new VueRouter({
  routes: [
    {path: '/', component: Home, meta: {noWrapper: true}},
    {path: '/login', component: Login, meta: {noWrapper: true}},
    {path: '/new-clients', component: NewClients},
    {path: '/declarations', component: Declarations},
    {path: '/invoices', component: Invoices},
    {path: '/client', component: ClientDetails, props: true},
    {path: '/client/edit-pricelist', component: EditClientPricelist, props: true, meta: {hideTopBar: true}},
    {path: '/invoices/:id', component: InvoiceDetails, props: true},
    {path: '/declarations/:id', component: DeclarationDetails, props: true},
    {path: '/pricelist', component: Pricelist, props: true},
    {path: '/pricelist/edit', component: EditPricelist, props: true},
    {path: '/debts', component: Debts, props: true},
    {path: '/limit-exceeded', component: CreditLimitExceededRaport, props: true},
    {path: '/transactions', component: Transactions, props: true},
    {path: '/tollreport', component: TollReport},
    {path: '/servicereport', component: ServiceReport},
    {path: '/admin/users', component: Users},
    {path: '/admin/services', component: Services},
    {path: '/admin/classifiers', component: Classifiers},
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (store.state.user == null && to.path !== '/login') {
    next('/login')
  } else {
    next()
  }
})

export default router
